import store from '@/store'
import axios from 'axios'

const isProduction = process.env.NODE_ENV === 'production'

const prodHost = 'https://api.maspocovendo.com'
const devHost = 'http://localhost:8082'
// const devHost = 'https://9779-2803-9800-9800-bf0a-ac30-ffec-e51b-6db4.ngrok-free.app'
const host = isProduction ? prodHost : devHost

const px = '/api'

export const urls = {
  // host: 'https://localhost',
  // host: 'https://maspocovendo.ddns.net',
  // ws: 'https://localhost/broadcasting/auth',
  host: `${host}`,
  ws: `${host}/broadcasting/auth`,
  login: `${px}/login`,
  logout: `${px}/logout`,
  facebook: `${px}/login/facebook`,
  facebookCallback: `${px}/login/facebook/callback`,
  google: `${px}/login/google`,
  googleCallback: `${px}/login/google/callback`,
  register: `${px}/register`,
  registerVerifyAccount: `${px}/register/verify`,
  registerResend: `${px}/register/email/resend`,
  ads: `${px}/advertisings`,
  publications: `${px}/publications`,
  categories: `${px}/categories/menu`,
  categoriesPredict: `${px}/categories/suggest`,
  categoriesSuggest: `${px}/categories/suggest/catalog_domains`,
  categoryPubs: `${px}/publications/categories`,
  me: `${px}/me`,
  refresh: `${px}/login/refresh`,
  locations: `${px}/publications/locations/search`,
  sellCategories: `${px}/publications/sell/categories`,
  sell: `${px}/publications/sell`,
  sellLocations: `${px}/publications/locations`,
  sellPhones: `${px}/publications/phones`,
  sellEmails: `${px}/publications/emails`,
  sellImages: `${px}/publications/media/sell`,
  publicationSellerAmount: `${px}/marketplace/seller-amount`,
  publicationOrder: `${px}/publications-orders`,
  publicationOrderPrice: `${px}/publications-orders/price-calculation`,
  publicationSheet: `${px}/publications/sheet`,
  publicationPhones: `${px}/publications`,
  userPublicationSheet: `${px}/me/publications/sheet`,
  publicationQuestions: `${px}/publications/questions`,
  publicationAnswers: `${px}/publications/answers`,
  publicationRepublish: `${px}/publications/republish`,
  publicationDelete: `${px}/publications/delete`,
  favorites: `${px}/users/favorites`,
  notifications: `${px}/users/notifications`,
  profile: `${px}/profiles/users`,
  publicationSearch: `${px}/publications/search`,
  userEmails: `${px}/users/emails`,
  userEmailVerify: `${px}/users/emails/verify`,
  userProfile: `${px}/users/profiles`,
  userPublications: `${px}/users/publications`,
  userPurchases: `${px}/marketplace/purchases`,
  userSales: `${px}/marketplace/sales`,
  userLocations: `${px}/users/locations`,
  userPhones: `${px}/users/phones`,
  userAvatar: `${px}/me/media`,
  userNotifications: `${px}/me/notifications`,
  userAnswers: `${px}/users/answers`,
  userNotificationsSetAllSeen: `${px}/me/notifications/all`,
  users: `${px}/users`,
  sendSMS: `${px}/send/sms`,
  sendCode: `${px}/password/reset/send-code`,
  sendNewPassword: `${px}/password/reset/code`,
  verifySMS: `${px}/verify/sms`,
  profileFollowing: `${px}/users/followings`,
  profileFollowers: `${px}/users/followers`,
  profilePublicFollowers: `${px}/users/get-followers`,
  followedPublications: `${px}/publications/followings`,
  checkingAccountMovements: `${px}/checking-account-movements`,
  pendingQuestions: `${px}/publications/questions/unanswered`,
  answeredQuestions: `${px}/publications/questions/answered`,
  passwordEmail: `${px}/password/email`,
  mpAuthorizationLink: `${px}/marketplace/authorization-link`, // send the user to MP with back-url = profile
  // mpAuthorizationLinkSell: `${px}/marketplace/authorization-link/sell`, // send the user to MP with the back-url = sell
  mpAuthorization: `${px}/marketplace/authorization`, // receive the code from MP
  marketplacePriceCalculation: `${px}/marketplace/price-calculation`,
  marketplaceOrders: `${px}/marketplace/orders`,
  marketplaceSaveShipment: `${px}/marketplace/shipments/orders`,
  marketplacePurchase: `${px}/marketplace/purchases/merchant-order`,
  marketplaceSale: `${px}/marketplace/sales/merchant-order`,
  marketplaceRefund: `${px}/marketplace/sales/refund`,
}

// kept for compatibility while all axios calls are replaced
axios.defaults.baseURL = urls.host

// it's better to export an api object, so axios can be replaces later
export const api = axios.create({
  baseURL: urls.host,
  mode: 'no-cors',
  headers: {
    // 'Access-Control-Allow-Origin': '*',
    ...(process.env.NODE_ENV === 'development' && {'ngrok-skip-browser-warning': 'true'})
  }
})

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

api.interceptors.response.use(res => {
  if (res.headers['front-public-vue-version'] === 'mant') {
    store.dispatch('setMaintenance', true)
  } else {
    const remoteVersion = parseFloat(res.headers['front-public-vue-version'])
    const localVersion = parseFloat(store.state.frontendVersion)
    const versionChecked = store.state.versionChecked

    if (!versionChecked && remoteVersion > localVersion) {
      store.dispatch('setFrontendOutOfDate', true)
    }
    store.dispatch('setVersionChecked', true)
  }

  return res
}, error => {
  const { config, response } = error
  const originalRequest = config

  if (response && response.status === 401) {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true
      store.dispatch('user/refresh').then((access_token) => {
        isAlreadyFetchingAccessToken = false
        onAccessTokenFetched(access_token)
      })
    }

    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber(access_token => {
        originalRequest.headers.Authorization = 'Bearer ' + access_token
        resolve(axios(originalRequest))
      })
    })
    return retryOriginalRequest
  }
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/api.js